import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SuccessStoriesPage = ({ user, onLogout }) => {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompanyInfo();
  }, []);

  const fetchCompanyInfo = async () => {
    try {
      const response = await axios.get(`${API}/public/company-info`);
      setCompanyInfo(response.data);
    } catch (error) {
      console.error('Error fetching company info:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar user={user} onLogout={onLogout} />
        <div className="flex items-center justify-center h-96">
          <div className="text-xl text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  if (!companyInfo?.success_stories) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar user={user} onLogout={onLogout} />
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Success Stories</h1>
          <p className="text-gray-600">Content coming soon...</p>
          <Link to="/" className="text-blue-600 hover:underline mt-4 inline-block">
            Return to Home
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" data-testid="success-stories-page">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-testid="success-stories-title">
            Success Stories
          </h1>
          <p className="text-xl text-gray-600">
            See how providers have grown their businesses with {companyInfo.company_name || 'us'}
          </p>
        </div>

        {/* Content */}
        <div 
          className="prose prose-lg max-w-none bg-white rounded-lg shadow-sm p-8"
          data-testid="success-stories-content"
          dangerouslySetInnerHTML={{ __html: companyInfo.success_stories }}
        />

        {/* CTA */}
        <div className="mt-12 text-center bg-gradient-to-r from-green-600 to-teal-600 rounded-lg p-8 text-white">
          <h2 className="text-2xl font-bold mb-4">Ready to Start Your Success Story?</h2>
          <p className="mb-6">Join thousands of providers earning on our platform.</p>
          <Link 
            to="/register" 
            className="inline-block bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
            data-testid="success-stories-cta"
          >
            Become a Provider
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default SuccessStoriesPage;
